module.exports = __webpack_public_path__ + "static/media/theperfectloaf.4b4447a8.jpg";